import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import useTranslation from '../../hooks/useTranslation';
import './styles.scss';

let Success = 'Success';
let Warning = 'Warning';
let ErrorTitle = 'Error';

const EpToaster = ({
  position, duration, hideProgressBar, newestOnTop,
}) => {
  // Tags do Globalization
  Success = useTranslation('Success');
  Warning = useTranslation('Warning');
  ErrorTitle = useTranslation('Error');

  return (
    <ToastContainer
      position={position}
      autoClose={duration}
      hideProgressBar={hideProgressBar}
      newestOnTop={newestOnTop}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};

const EpCustomToast = ({
  title, description, hasTitle,
}) => (
  <div className="toast toast--custom show">
    {!hasTitle && (
      <h6 className="toast__title">{title}</h6>
    )}
    <p className="toast__message">{description}</p>
  </div>
);

export function showToast(
  color, title, description, hasTitle,
) {
  toast(
    <EpCustomToast
      color={color}
      title={title}
      description={description}
      hasTitle={hasTitle}
    />,
    { type: color },
  );
}

export const showToastDefault = (res, toasterTitle, toasterDescription) => {
  const errorCode = res.status || res.response.status;

  switch (errorCode) {
  case 200:
    return showToast('success', toasterTitle || Success, toasterDescription || res.statusText);
  case 204:
    return showToast('success', toasterTitle || Success, toasterDescription || res.statusText);
  case 422:
    return showToast('warning', toasterTitle || Warning, toasterDescription || res.message);
  default:
    return showToast('error', toasterTitle || ErrorTitle, toasterDescription || res.message);
  }
};

export default EpToaster;

EpCustomToast.defaultProps = {
  hasTitle: false,
};

EpCustomToast.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hasTitle: PropTypes.bool,
};

EpToaster.defaultProps = {
  position: 'top-right',
  duration: 5000,
  hideProgressBar: false,
  newestOnTop: true,
};

EpToaster.propTypes = {
  position: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
  duration: PropTypes.number,
  hideProgressBar: PropTypes.bool,
  newestOnTop: PropTypes.bool,
};
